module.exports = __webpack_public_path__ + "static/media/family.bfd7b7eb.webp";